export default "__VITE_ASSET__CcaEAsDu__"